import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateDatasetDataState from './datasetData';
import updateDictionaryDataState from './dictionaryData';

const handlers = {
  ...updateDatasetDataState,
  ...updateDictionaryDataState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
